export const tree = {
    tabs: {
        presentation: {
            acl: 'g:admin,g:qs',
            datatype: [
                21
            ],
            tabGroup: 'overview',
            parts: [
                'PresentationEditor'
            ],
            label: 'Präsentation'
        },
        textticker: {
            acl: 'g:admin,g:qs',
            enabled: ({ datatype, subtype })=>datatype == 21 && [
                    52,
                    60
                ].includes(subtype),
            tabGroup: 'overview',
            parts: [
                'VlmTextTickerEditor'
            ],
            label: 'Edit'
        }
    }
};
export const exhibition = {
    layout: 'L1Col',
    filters: [
        {
            type: 'ancestorAxisJson'
        }
    ],
    tabs: {
        view: {
            parts: [
                {
                    type: 'PresentationViewer',
                    style: {
                        height: '100vh'
                    }
                }
            ]
        }
    }
};
